import { IRootState, ISubscriptionsState } from '@/@types'

import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

const subscriptions: Module<ISubscriptionsState, IRootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}

export default subscriptions
